module.exports = __webpack_public_path__ + "img/Najarian2.3a1ae50d.jpg";